/**
 * Minimum quantity allowed for charge sheet line items.
 */
export const MIN_QUANTITY = 0.01
